import { render } from "./LoginFooter.vue?vue&type=template&id=ab2694e2"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__